let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4cY42")).then(() => parcelRequire('c2H7b'));